export default __webpack_public_path__ + "static/large-cabin-kitchen-5d8c6b822762e2198ddf1d8a1465f586.jpg";